export enum SubscriberType {
    Unknown = 'Unknown',
    Primary = 'Primary',
    Secondary = 'Secondary',
}

export default SubscriberType;
